import { Button } from "@mui/material";
import {caseInsensitiveSort, sortIntegerValues} from "../../common/Utils";
const selected=(data)=>{
	if(data)
	return "green"
	
	}
export const careFacilityAuditColumns = [
    {
		name: 'Log Id',
		minWidth:"100px",
		selector: row => <div style={{overflow:"hidden",textOverflow:"ellipsis"}}>{row.id}</div>,
        sortable: true,
		center:true,
		style: {
			justifyContent: "center",
			textAlign:"center",
			minWidth:"100px",
		},
		sortFunction: (rowA, rowB) => sortIntegerValues(rowA, rowB, (row) => row.id? row.id:""),
	},
	{
		name: 'Care Facility Id',
		selector: row => <div style={{overflow:"hidden",textOverflow:"ellipsis"}}>{row.keyId}</div>,
        sortable: true,
        minWidth:"150px",
		center:true,
		style: {
			justifyContent: "center",
			textAlign:"center",
			minWidth:"150px",
		},
		sortFunction: (rowA, rowB) => sortIntegerValues(rowA, rowB, (row) => row.keyId? row.keyId:""),
	},
	{
		name: 'Care Facility Name',
		selector: row => <div style={{overflow:"hidden",textOverflow:"ellipsis"}}>{row.careFacilityName}</div>,
        sortable: true,
		minWidth:"220px",
		center:true,
		style: {
			justifyContent: "center",
			textAlign:"center",
			minWidth:"220px",
		},
		sortFunction: (rowA, rowB) => caseInsensitiveSort(rowA, rowB, (row) =>row.careFacilityName? row.careFacilityName: ""),
	},
	{
		name: 'Updated By',
		selector: row => <div style={{overflow:"hidden",textOverflow:"ellipsis"}}>{row.updatedBY}</div>,
		sortable: true,
		minWidth: "230px",
		center:true,
		style: {
			justifyContent: "center",
			textAlign:"center",
			minWidth: "230px",
		},
		sortFunction: (rowA, rowB) => caseInsensitiveSort(rowA, rowB, (row) => row.updatedBY? row.updatedBY:""),
	},
	{
		name: 'Updated At',
		selector: row => <div style={{overflow:"hidden",textOverflow:"ellipsis"}}>{row.updatedAt}</div>,
        sortable: true,
		minWidth:"180px",
		center:true,
		style: {
			justifyContent: "center",
			textAlign:"center",
			minWidth:"180px",
		},
		sortFunction: (rowA, rowB) => sortIntegerValues(rowA, rowB, (row) => row.updatedAt? row.updatedAt:""),
	},
	{
		name: 'Action',
		selector: row => <div style={{overflow:"hidden",textOverflow:"ellipsis"}}>{row.action}</div>,
        sortable: true,
		minWidth:"100px",
		center:true,
		style: {
			justifyContent: "center",
			textAlign:"center",
			minWidth:"100px",
		},
		sortFunction: (rowA, rowB) => caseInsensitiveSort(rowA, rowB, (row) => row.action? row.action: ""),
	},
	{
		name: '',
		sortable:true,
		field:'action',	
		minWidth: "180px",
		center:true,
		style: {
			justifyContent: "center",
			textAlign:"center",
			minWidth: "180px",
		},
		cell: row =><div style={{overflow:"hidden",textOverflow:"ellipsis"}}> 
				<Button sx={{color:{selected}, textTransform:'unset !important', width:"120px",margin:"10px"}} 
				variant="outlined" row={row} data-tag="allowRowEvents" 
				> Select </Button>
				</div>
	},
];

export const careFacilityAuditExcelColumns = [
    {
		header: 'Log Id',
		key: 'id',
	},
	{
		header: 'Care Facility Id',
		key: 'keyId',
	},
	{
		header: 'CareFacility Name',
		key: 'careFacilityName',
	},
	{
		header: 'Old Values',
		key: 'oldValues',
	},
	{
		header: 'New Values',
		key: 'newValues',
	},
	{
		header: 'Updated By',
		key: 'updatedBY',
	},
	{
		header: 'Updated At',
		key: 'updatedAt',
	},
	{
		header: 'Action',
		key: 'action',
	}
];


